// extracted by mini-css-extract-plugin
export default {"card":"_5DncS5zF","buttons":"_5DDln7fM"};